module.exports = __webpack_public_path__ + "static/media/9.46a00d84.jpg";